import { Injectable } from '@angular/core';
import type { Role, UpdateRolePayload } from '../interfaces/application';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class RolesService extends CrudService<Role, Role, UpdateRolePayload>{

  constructor() {
    super('roles');
  }
}
